/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { CurrentUserFragment } from '../../../../queries/types/CurrentUserFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CustomerLoginVariables = Types.Exact<{
  email: Types.Scalars['String']
  password: Types.Scalars['String']
  resetTokenAfterLogin: Types.InputMaybe<Types.Scalars['Boolean']>
}>

export type CustomerLogin = {
  __typename: 'Root'
  customerLogin: {
    __typename: 'CustomerLoginPayload'
    redirectTo: string | null
    errors: Array<{
      __typename: 'UserError'
      key: string | null
      fullMessage: string | null
      message: string | null
    }> | null
    customer: {
      __typename: 'Customer'
      id: number
      name: string | null
      firstName: string | null
      lastName: string | null
      email: string
      phone: any | null
      completeProfile: boolean
      anonymous: boolean
      authenticationToken: string
      referralCode: string
      tawkHash: string | null
      trackingOptedOut: boolean
      amountCredit: { __typename: 'Money'; cents: number; formatted: string }
    } | null
  } | null
}

export const CustomerLoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CustomerLogin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'password' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'resetTokenAfterLogin' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerLogin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'password' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resetTokenAfterLogin' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'resetTokenAfterLogin' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CurrentUserFragment' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectTo' } }
              ]
            }
          }
        ]
      }
    },
    ...CurrentUserFragment.definitions
  ]
} as unknown as DocumentNode
export type CustomerLoginMutationFn = Apollo.MutationFunction<
  CustomerLogin,
  CustomerLoginVariables
>

/**
 * __useCustomerLogin__
 *
 * To run a mutation, you first call `useCustomerLogin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerLogin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerLogin, { data, loading, error }] = useCustomerLogin({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      resetTokenAfterLogin: // value for 'resetTokenAfterLogin'
 *   },
 * });
 */
export function useCustomerLogin(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CustomerLogin,
    CustomerLoginVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CustomerLogin, CustomerLoginVariables>(
    CustomerLoginDocument,
    options
  )
}
export type CustomerLoginHookResult = ReturnType<typeof useCustomerLogin>
export type CustomerLoginMutationResult = Apollo.MutationResult<CustomerLogin>
export type CustomerLoginMutationOptions = Apollo.BaseMutationOptions<
  CustomerLogin,
  CustomerLoginVariables
>
